import {getStore} from 'src/v2/state/store';
import {Text} from 'src/v2/components/common/Text';
import {LinkTitleWrapper} from 'src/v2/components/screen/link/LinkTitleWrapper';
import {useAmountDisplay} from 'src/v2/state/useAmountDisplay';

import {message, useIntl} from '@sail/intl';
import {view} from '@sail/ui';

const messages = {
  title: message<{
    businessName: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.heading.pay_title',
    description: 'Header for the payment screen',
    defaultMessage: 'Pay {businessName}',
  }),

  smallTitle: message<{
    businessName: React.ReactNode;
    amount: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.heading.pay_title_small',
    description: 'Compact one-line header showing business name and amount',
    defaultMessage: 'Pay {businessName} {amount}',
  }),

  genericTitle: message({
    id: 'crypto.payins.v2.heading.pay_with_crypto',
    description: 'Generic header for the payment screen',
    defaultMessage: 'Pay with crypto',
  }),
};

export const PayTitle = () => {
  const intl = useIntl();
  const store = getStore();

  const businessName = store.useSelector(
    (state) => state.merchantBranding.businessName,
  );

  const useGenericTitle = store.useSelector(
    (state) => state.featureFlags.crypto_payins_generic_payment_title,
  );

  const enablePayWithAnyCrypto = store.useSelector(
    (state) => state.featureFlags.enable_pay_with_any_crypto,
  );

  const amountDisplay = useAmountDisplay();

  if (enablePayWithAnyCrypto) {
    return (
      <view.div
        css={{
          stack: 'y',
          alignX: 'center',
          alignY: 'center',
        }}
      >
        <Text type="labelEmphasized" css={{color: 'text'}}>
          {intl.formatMessage(messages.smallTitle, {
            businessName,
            amount: amountDisplay,
          })}
        </Text>
      </view.div>
    );
  }

  return (
    <LinkTitleWrapper>
      <Text type="headline" css={{color: 'text'}}>
        {useGenericTitle
          ? intl.formatMessage(messages.genericTitle)
          : intl.formatMessage(messages.title, {businessName})}
      </Text>

      <Text type="heading" css={{color: 'text'}}>
        {amountDisplay}
      </Text>
    </LinkTitleWrapper>
  );
};
